export class organization {
    ////measuers: measuers[];
    //measuers: Array<measuers>;
    //orgTotalItems:number;
    //constructor() {
    //    this.measuers = new Array();
    //}
  measureId: number;
  measureCode: string;
    measureName: string;
    totalItems:number;
    contrcatTemplates: Array<template>;
}


export class template {
    templateId: number;
    templateTag: string;
    performance: number;
    met: number;
    notMet: number;
    denominator: number;
    exclusion: number;
    eligible: number;
    goal: number;
    exception: number;
}
